import React, { useState } from "react"
import Accordion from "react-bootstrap/Accordion"
import Card from "react-bootstrap/Card"
import styled from "styled-components"

import { colors } from "../../utils/theme"
import { device } from "../../utils/breakpoints"

const AcordeonFaqs = styled(Accordion)`
  margin-top: 1rem;
  h3{
    color: white;
    font-weight: 700;
    font-size: 1.3em;
    padding: 1em;
  }
  .card {
    background: transparent;
    border: none;
    padding: 6px;
    transition: 1s ease-in-out;
    overflow: inherit;
    & .card-header {
      border-radius: 0px;
      background: transparent;
      color: white;
      font-weight: 800;
      border-bottom: none;
      box-shadow: 0 0 10px rgba(112, 0, 227, 0.1);
      padding: 1.5rem 2rem;
      display: flex;
      flex-direction: row;
      align-items: center;
      position: relative;
      transition: 0.3s ease-in-out;
      font-size: 0.9em;
      cursor: pointer;
      @media ${device.md} {
      }
      &.active {
        color: white;
        background: ${colors.pColor};
        font-size: 1em;
        box-shadow: 0 3px 16px rgba(112, 0, 227, 0.2);
        & .title-header {
          & .question {
            color: white;
            padding-left: 1rem;
            @media ${device.md} {
              padding-left: 1rem;
            }
          }
        }
        &:after {
          position: absolute;
          content: "-";
          color: white;
          right: 2rem;
          top: 50%;
          transform: translateY(-50%);
        }
      }
      &:after {
        content: "+";
        position: absolute;
        right: 2rem;
        top: 50%;
        transform: translateY(-50%);
        font-size: 1.5rem;
        font-weight: 600;
        color: ${colors.pColor};
      }
      & img {
        width: 50px;
        margin-right: 1rem;
      }
      & .title-header {
        display: flex;
        align-items: flex-start;
        flex-direction: column;
        justify-content: center;
        padding-right: 2rem;
        text-align: left;
        @media ${device.md} {
          flex-direction: row;
        }
        & .unity {
          font-size: 0.9em;
          margin: 0;
          font-weight: 800;
          line-height: inherit;
        }
        & .question {
          color: #cecece;
          font-size: 0.9em;
          padding-left: 1rem;
          @media ${device.md} {
            padding-left: 1rem;
          }
        }
      }
    }
    & .card-body {
      padding-bottom: 0;
      & .info-class {
        display: flex;
        align-items: flex-start;
        flex-direction: column;
        & .icon-class {
          padding: 0 1rem;
          & img {
            height: auto;
            width: 35px;
            margin-bottom: 0.5rem;
          }
        }
        @media ${device.md} {
          display: flex;
          align-items: flex-start;
          flex-direction: row;
          & .icon-class {
            & img {
              width: 45px;
            }
          }
        }

        & .description {
          padding: 0 1rem;
          & h4 {
            font-weight: 700;
            font-size: 1em;
            color: white;
          }
          & p {
            margin-bottom: 0;
            padding-bottom: 1rem;
            font-size: 0.8em;
            color: white;
          }
          @media ${device.md} {
            & h4 {
              font-weight: 700;
              font-size: 1em;
              color: #313131;
            }
            & p {
              padding-bottom: 1rem;
            }
          }
        }
      }
    }
  }
`

const FaqsAccordeon = () => {
  const [temario, setTemario] = useState([
    {
      id: 1,
      question: "¿Quién puede tomar este MÁSTER?",
      active: true,
      answer:
        "1.	Pueden tomar personas con conocimientos básicos en el ámbito del 3d. En el  curso se utilizará programas como: Blender, Zbrush, Substance Painter.",
    },
    {
      id: 2,
      question: "¿Por qué elegir a LIBEL STUDIOS?",
      active: false,
      answer: `Libel studios es una empresa dedicada a la formación 3d. Tiene instructores calificados con experiencia. Lo que garantiza resultados óptimos y reales.`,
    },
    {
      id: 3,
      question: "¿Qué medios de pago tienen?",
      active: false,
      answer:
        "Tenemos medios de pago dependiendo el país, PAYPAL, VISA, TRANSFERENCIA, WENSTER UNION entre otros, más información en Whatsapp: +573142332824.",
    },
    {
      id: 4,
      question: "¿Qué conocimientos tendré al finalizar el MÁSTER?",
      active: false,
      answer:
        "El estudiante al finalizar el curso,  tendrá conocimientos solidos para poder crear sus propias aventuras dentro del fascinante mundo 3d.",
    },
    {
      id: 5,
      question: "¿Si pierdo una clase como la puedo reponer?",
      active: false,
      answer: `Las clases son grabadas, las podrá revisar en línea en el momento que el alumno lo desee.`,
    },
  ])
  const handleAccordeon = unity => {
    const findIndex = temario.findIndex(element => element.id === unity.id)
    const newTemario = temario.map(ele => {
      if (ele.id === unity.id) {
        ele.active = true
        return ele
      } else {
        ele.active = false
        return ele
      }
    })
    setTemario(newTemario)
  }
  return (
    <>
      <AcordeonFaqs defaultActiveKey={1}>
        <h3 >
          Preguntas Frecuentes
        </h3>
        {temario.map(question => (
          <Card key={question.id}>
            <Accordion.Toggle
              as={Card.Header}
              eventKey={question.id}
              className={question.active ? "active" : ""}
              onClick={() => handleAccordeon(question)}
            >
              {question.active ? (
                <span>{question.id}.</span>
              ) : (
                <span>{question.id}.</span>
              )}
              <div className="title-header">
                {/* <h3 className="unity">
                <span>{unity.name}: </span>{" "}
              </h3> */}
                <span className="question">{question.question}</span>
              </div>
            </Accordion.Toggle>
            <Accordion.Collapse eventKey={question.id}>
              <Card.Body>
                <div className="info-class">
                  <div className="description">
                    <p>{question.answer}</p>
                  </div>
                </div>
              </Card.Body>
            </Accordion.Collapse>
          </Card>
        ))}
      </AcordeonFaqs>
    </>
  )
}

export default FaqsAccordeon
